export const SCORE_PROGRESS_MESSAGES = {
  NO_HISTORY: "No scoring history available",
} as const;

export const SCORE_PROGRESS_SCROLL = {
  END_THRESHOLD: 10,
} as const;

export const SCORE_PROGRESS_SELECTORS = {
  PROGRESS_CARD: ".progress-card",
  ARROW: ".arrow",
} as const;
